import { UnstyledButton } from "@mantine/core";

import styles from "./DynamicToneGuidance.module.css";

interface UseUpdateButtonProps {
    onClick: () => void;
}

export const UseUpdateButton = ({ onClick }: UseUpdateButtonProps) => (
    <UnstyledButton className={styles.useUpdateButton} onClick={onClick}>
        Use updates
    </UnstyledButton>
);
